import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    Text,
    Stack,
    StackItem,
} from '@fluentui/react';
import ButtonPrimaryComponent from '../../components/button-primary/button-primary.component';
import ErrorMessageComponent from '../../components/error-message/error-message.component';
import LoaderComponent from '../../components/loader/loader.component';
import SuccessMessageComponent from '../../components/success-message/success-message.component';
import queryString from "query-string";
import { Buffer } from "buffer";

import ItemCliente from '../../models/ItemCliente';
import useAuthStatus from '../../hooks/auth/AuthHook';

interface IRegisterConfirmPageProps {};

interface IRegisterConfirmPageParams {
    ItemCliente: ItemCliente;
    Token: string;
};

const RegisterConfirmPage = (props: IRegisterConfirmPageProps) => {
    const auth = useAuthStatus();

    const [params, setParams] = useState<IRegisterConfirmPageParams>();
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string>('');
    const [success, setSuccess] = useState<string>('');

    const navigate = useNavigate();

    useEffect(() => {
        let queryParams : queryString.ParsedQuery<string> = queryString.parse(window.location.search);
        setParams(JSON.parse(Buffer.from(queryParams.ItemRegistroConfirmar?.toString() || "", 'base64').toString('ascii')));
    }, []);

    useEffect(() => {
        if (params) {
            setLoading(true);
            auth.confirmRegister(params.ItemCliente, params.Token).then((response: string) => {
                setSuccess(response);
                setLoading(false);
            }, (error: string) => {
                setError(error);
                setLoading(false);
            });
        }
    }, [params]);

    return (
        <>
            <Stack>
                <StackItem className='mb-3'>
                    <Text 
                        className='fw-bold'
                        variant='large'>
                        Registro profesional:
                    </Text>
                </StackItem>
                <StackItem className='mb-3'>
                    <SuccessMessageComponent message={success} />
                </StackItem>
                <StackItem className='mb-3'>
                    <ErrorMessageComponent message={error} />
                </StackItem>
                <StackItem className='mb-3'>
                    <ButtonPrimaryComponent 
                        className='text-uppercase'
                        text='Iniciar sesión'
                        onClick={() => navigate("/")} />
                </StackItem>
            </Stack>
            <LoaderComponent loading={loading} />
        </>
    );
};

export default RegisterConfirmPage;
